import React from 'react';

type ReturnsTabContextValue = {
  hasLegacyBrandedReturns: boolean;
  isEnhancedReturnsAvailableOnAnyPlan: boolean;
  isEnhancedReturnsFeatureEnabled: boolean;
  isLegacyBrandedReturnsFeatureAvailableOnAnyPlan: boolean;
  isStoreSetupCompleteForEnhancedReturns: boolean;
  isShipstationReturnsEnabled: boolean;
  marketplaceName: string;
  showStandardReturnPortalConfigForEnhancedStore: boolean;
  storeGuid: string;
  supportsEnhancedReturns: boolean;
  useBrandedReturns: boolean;
};

const ReturnsTabContext = React.createContext<ReturnsTabContextValue>({} as ReturnsTabContextValue);
export const useReturnsTabContext = () => React.useContext(ReturnsTabContext);

export const ReturnsTabContextProvider = ({ children, value }: { children: React.ReactNode; value: ReturnsTabContextValue }) => {
  return <ReturnsTabContext.Provider value={value}>{children}</ReturnsTabContext.Provider>;
};
